import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCSVWithBom } from "../../helpers/methods";

export const exporter = (locale) => (contacts) => {
  const contactsForExport = contacts.map((contact) => {
    const {
      __v,
      _id,
      page,
      createdAt,
      updatedAt,
      credit,
      ...contactForExport
    } = contact; // omit backlinks and author

    return {
      ...contactForExport,
      credit: (credit / 100).toFixed(2),
      createdAt: new Date(createdAt).toLocaleString(locale),
      updatedAt: new Date(updatedAt).toLocaleString(locale),
    };
  });
  const csv = convertToCSV({
    data: contactsForExport,
    fields: [
      "id",
      "psid",
      "name",
      "phoneNumber",
      "isBlacklisted",
      "email",
      "credit",
      "rating",
      "remarks",
      "createdAt",
      "updatedAt",
    ],
  });
  downloadCSVWithBom(csv, `contacts_${new Date().toLocaleDateString(locale)}`); // download as 'vouchers.csv` file
};
